import { useEffect, useState } from "react";
import instance from "../axios";

const UseFetchWithScroll = (url, page, setPage) => {
  const [data, setData] = useState([]);
  const [totalPage, setTotalPage] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [error, setError] = useState(true);

  const handleScroll = (e) => {
    const scrollHeight = e.target.documentElement.scrollHeight;
    const scrollTop = e.target.documentElement.scrollTop;
    const innerHeight = window.innerHeight;

    if (scrollHeight - (scrollTop + innerHeight) < 500) {
      setIsFetching(true);
    }
  };

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isFetching) {
      instance(true)
        .get(url)
        .then((res) => {
          setData((prevState) => {
            return [...prevState, ...res.data?.results];
          });
          setTotalPage(res.data?.total_pages);
          setPage((page) => page + 1);
        })
        .catch((error) => {
          setError(error.message);
        })
        .finally(() => {
          setIsFetching(false);
        });
    }
  }, [isFetching]);

  return { data, page, totalPage, isFetching, error };
};

export default UseFetchWithScroll;
